import { createActionHelpers } from 'vuex-loading';
import Big from 'big.js';
import localForage from 'localforage';
import Auth from '@js/plugins/auth';
import * as type from '../mutation-types';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const store = localForage.createInstance({
    storeName: `reimbursement_${Auth.user().id}`,
    namespaced: true,
});

const Laroute = require('../../laroute');

store.getItem('filters').then(filters => {
    if (filters) {
        state.filters = filters;
    }
});

const state = {
    searchMeta: null,
    filters: [],
    cardList: [],
    terminalList: [],
    lastQuery: null,
    cardTypes: [],
};

const mutations = {
    [type.SET_CARD_LIST](state, region) {
        state.cardList = region;
    },

    setSearchMeta(state, meta) {
        state.searchMeta = meta;
    },

    async setFilters(state, filters) {
        state.filters = filters;
        await store.setItem('filters', filters);
    },

    setLastQuery(state, query) {
        state.lastQuery = query;
    },

    setTerminalList(state, query) {
        state.terminalList = query;
    },

    setCardTypes(state, cards) {
        state.cardTypes = cards;
    },
};

const actions = {
    getTerminalListIfNecessary({ commit, dispatch }, params = {}) {
        const route = Laroute.route(
            'franchise.report.reimbursement.terminal-list',
        );

        let options = {
            params: _.merge(
                {
                    limit: 100,
                    query: null,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-reimbursement');

        return axios
            .get(route, options)
            .then(res => {
                let data = res.data;

                commit('setTerminalList', data);
                commit('setLastQuery', options.params.query);
                endLoading(dispatch, 'fetch-reimbursement');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-reimbursement');
                throw err;
            });
    },

    getCardListIfNecessary({ commit, dispatch }, params = {}) {
        if (!state.cardList.length || state.lastQuery != params.query) {
            return dispatch('getCardList', params);
        }

        return Promise.resolve(state.cardList);
    },

    getCardList({ commit, dispatch }, params) {
        let options = {
            params: _.merge(
                {
                    limit: 100,
                    query: null,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-reimbursement');

        return axios
            .get(Laroute.route('franchise.vue.cards'), options)
            .then(res => {
                let data = res.data.data;

                commit(type.SET_CARD_LIST, data);
                commit('setLastQuery', options.params.query);
                endLoading(dispatch, 'fetch-reimbursement');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-reimbursement');
                throw err;
            });
    },

    getSearchMeta({ commit, dispatch }) {
        const route = Laroute.route(
            'franchise.report.reimbursement.search.meta',
        );

        startLoading(dispatch, 'get-reimbursement');

        return axios
            .get(route)
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-reimbursement');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-reimbursement');
                throw err;
            });
    },

    getSearchMetaIfNecessary({ commit, dispatch }) {
        if (!state.searchMeta) {
            return dispatch('getSearchMeta');
        }

        return Promise.resolve(state.searchMeta);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
